/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ResponseObject', 'model/ResponseRoleResponse', 'model/RoleActionResource', 'model/RoleResource', 'model/RolesResponse', 'model/RolesToAccountResponse'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ResponseObject'), require('../model/ResponseRoleResponse'), require('../model/RoleActionResource'), require('../model/RoleResource'), require('../model/RolesResponse'), require('../model/RolesToAccountResponse'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.RolesApi = factory(root.GisServerApis.ApiClient, root.GisServerApis.ResponseObject, root.GisServerApis.ResponseRoleResponse, root.GisServerApis.RoleActionResource, root.GisServerApis.RoleResource, root.GisServerApis.RolesResponse, root.GisServerApis.RolesToAccountResponse);
  }
}(this, function(ApiClient, ResponseObject, ResponseRoleResponse, RoleActionResource, RoleResource, RolesResponse, RolesToAccountResponse) {
  'use strict';

  /**
   * Roles service.
   * @module api/RolesApi
   * @version 1.0.0
   */

  /**
   * Constructs a new RolesApi. 
   * @alias module:api/RolesApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the addActionsToRoleV1 operation.
     * @callback module:api/RolesApi~addActionsToRoleV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Add actions to a specified role.
     * @param {String} roleId The ID of the role to be added to.
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/RoleActionResource>} opts.actions The actions will be added to the role. Each item includes the information: name, route and verb.
     * @param {module:model/String} opts.mapMode The map mode, it indicates how to handle with the existing items.               The supported values are \&quot;Append\&quot;, \&quot;Reset\&quot;. The defaults is \&quot;Append\&quot;
     * @param {module:api/RolesApi~addActionsToRoleV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.addActionsToRoleV1 = function(roleId, opts, callback) {
      opts = opts || {};
      var postBody = opts['actions'];

      // verify the required parameter 'roleId' is set
      if (roleId === undefined || roleId === null) {
        throw new Error("Missing the required parameter 'roleId' when calling addActionsToRoleV1");
      }


      var pathParams = {
        'roleId': roleId
      };
      var queryParams = {
        'mapMode': opts['mapMode'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/roles/{roleId}/actions', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the createRoleV1 operation.
     * @callback module:api/RolesApi~createRoleV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseRoleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new role.
     * @param {Object} opts Optional parameters
     * @param {module:model/RoleResource} opts.role The information of the role to be created. It includes a required field Name, an optional Description and AutoAssign.
     * @param {module:api/RolesApi~createRoleV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseRoleResponse}
     */
    this.createRoleV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['role'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseRoleResponse;

      return this.apiClient.callApi(
        '/api/v1/roles', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteRoleByIdV1 operation.
     * @callback module:api/RolesApi~deleteRoleByIdV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete role by ID.
     * @param {String} roleId The ID of the role to be deleted.
     * @param {module:api/RolesApi~deleteRoleByIdV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.deleteRoleByIdV1 = function(roleId, callback) {
      var postBody = null;

      // verify the required parameter 'roleId' is set
      if (roleId === undefined || roleId === null) {
        throw new Error("Missing the required parameter 'roleId' when calling deleteRoleByIdV1");
      }


      var pathParams = {
        'roleId': roleId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/roles/{roleId}', 'DELETE',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deletetRolesByIdsV1 operation.
     * @callback module:api/RolesApi~deletetRolesByIdsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete roles by IDs
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.roleIds The IDs of the roles to be deleted.
     * @param {module:api/RolesApi~deletetRolesByIdsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.deletetRolesByIdsV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
        'roleIds': {
          value: opts['roleIds'],
          collectionFormat: 'multi'
        },
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/roles', 'DELETE',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getRoleByIdV1 operation.
     * @callback module:api/RolesApi~getRoleByIdV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseRoleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get role by ID.
     * @param {String} roleId The ID of the role to query.
     * @param {module:api/RolesApi~getRoleByIdV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseRoleResponse}
     */
    this.getRoleByIdV1 = function(roleId, callback) {
      var postBody = null;

      // verify the required parameter 'roleId' is set
      if (roleId === undefined || roleId === null) {
        throw new Error("Missing the required parameter 'roleId' when calling getRoleByIdV1");
      }


      var pathParams = {
        'roleId': roleId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseRoleResponse;

      return this.apiClient.callApi(
        '/api/v1/roles/{roleId}', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getRolesForAccountV1 operation.
     * @callback module:api/RolesApi~getRolesForAccountV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/RolesToAccountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the roles for a specified account.
     * @param {String} accountId The ID of an account to query.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.offset The start index of the records.
     * @param {Number} opts.length The page size of per page.
     * @param {module:model/String} opts.returnMode The return mode, it indicates the information of the roles to return.               The supported values are \&quot;All\&quot;, \&quot;CountOnly\&quot;, \&quot;NameOnly\&quot;, \&quot;IdOnly\&quot; and \&quot;UriOnly\&quot;. The defaults is \&quot;All\&quot;
     * @param {String} opts.whereClause The name of the role to search.
     * @param {module:api/RolesApi~getRolesForAccountV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RolesToAccountResponse}
     */
    this.getRolesForAccountV1 = function(accountId, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getRolesForAccountV1");
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
        'offset': opts['offset'],
        'length': opts['length'],
        'returnMode': opts['returnMode'],
        'whereClause': opts['whereClause'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = RolesToAccountResponse;

      return this.apiClient.callApi(
        '/api/v1/roles/accounts/{accountId}', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getRolesForCurrentAccountV1 operation.
     * @callback module:api/RolesApi~getRolesForCurrentAccountV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/RolesToAccountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the roles for current account.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.offset The start index of the records.
     * @param {Number} opts.length The page size of per page.
     * @param {module:model/String} opts.returnMode The return mode, it indicates the information of the roles to return.               The supported values are \&quot;All\&quot;, \&quot;CountOnly\&quot;, \&quot;NameOnly\&quot;, \&quot;IdOnly\&quot; and \&quot;UriOnly\&quot;. The defaults is \&quot;All\&quot;
     * @param {String} opts.whereClause The name of the role to search.
     * @param {module:api/RolesApi~getRolesForCurrentAccountV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RolesToAccountResponse}
     */
    this.getRolesForCurrentAccountV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'offset': opts['offset'],
        'length': opts['length'],
        'returnMode': opts['returnMode'],
        'whereClause': opts['whereClause'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = RolesToAccountResponse;

      return this.apiClient.callApi(
        '/api/v1/roles/accounts/current', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getRolesV1 operation.
     * @callback module:api/RolesApi~getRolesV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/RolesResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the roles in pagination.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.offset The start index of the records.
     * @param {Number} opts.length The page size of per page.
     * @param {module:model/String} opts.returnMode The return mode, it indicates the information of the roles to return.               The supported values are \&quot;All\&quot;, \&quot;CountOnly\&quot;, \&quot;NameOnly\&quot;, \&quot;IdOnly\&quot; and \&quot;UriOnly\&quot;. The defaults is \&quot;All\&quot;
     * @param {String} opts.whereClause The name of the role to search.
     * @param {module:api/RolesApi~getRolesV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RolesResponse}
     */
    this.getRolesV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'offset': opts['offset'],
        'length': opts['length'],
        'returnMode': opts['returnMode'],
        'whereClause': opts['whereClause'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = RolesResponse;

      return this.apiClient.callApi(
        '/api/v1/roles', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the removeActionsFromRoleV1 operation.
     * @callback module:api/RolesApi~removeActionsFromRoleV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Remove the actions from a specificed role.
     * @param {String} roleId The ID of the role that the actions are removed from.
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/RoleActionResource>} opts.actions The actions to be removed.
     * @param {module:api/RolesApi~removeActionsFromRoleV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.removeActionsFromRoleV1 = function(roleId, opts, callback) {
      opts = opts || {};
      var postBody = opts['actions'];

      // verify the required parameter 'roleId' is set
      if (roleId === undefined || roleId === null) {
        throw new Error("Missing the required parameter 'roleId' when calling removeActionsFromRoleV1");
      }


      var pathParams = {
        'roleId': roleId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/roles/{roleId}/actions', 'DELETE',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateRoleV1 operation.
     * @callback module:api/RolesApi~updateRoleV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseRoleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updat the role.
     * @param {String} roleId 
     * @param {Object} opts Optional parameters
     * @param {module:model/RoleResource} opts.role The information of the role to be updated.
     * @param {module:api/RolesApi~updateRoleV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseRoleResponse}
     */
    this.updateRoleV1 = function(roleId, opts, callback) {
      opts = opts || {};
      var postBody = opts['role'];

      // verify the required parameter 'roleId' is set
      if (roleId === undefined || roleId === null) {
        throw new Error("Missing the required parameter 'roleId' when calling updateRoleV1");
      }


      var pathParams = {
        'roleId': roleId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseRoleResponse;

      return this.apiClient.callApi(
        '/api/v1/roles/{roleId}', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));

